import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" The images are broken due to the specific URL formatting ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, "PreLoader", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, "Language", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" TagSelect "),
  /*#__PURE__*/_createElementVNode("span", null, "title: string + selectItems: [string]")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode("ButtonShare"),
  /*#__PURE__*/_createElementVNode("span", null, "text: string")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, "SharePopup", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode("DayMenuButtons "),
  /*#__PURE__*/_createElementVNode("span", null, "text: [string]")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode("ScheduleDayMenuButtons "),
  /*#__PURE__*/_createElementVNode("span", null, "text: [string]")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode("TagContainer "),
  /*#__PURE__*/_createElementVNode("span", null, "text: [string]")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, "SearchBar", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" Select"),
  /*#__PURE__*/_createElementVNode("span", null, "selectItems: [string] + title: string")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" Button "),
  /*#__PURE__*/_createElementVNode("span", null, "mainColor: string + hoverColor: string + text: string + padd: string + link: string")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" SocialMediaButtons "),
  /*#__PURE__*/_createElementVNode("span", null, "facebook: string + twitter: string + instagram: string + etc")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" ScheduleCardByHour "),
  /*#__PURE__*/_createElementVNode("span", null, "event: {} + id: string + link: string + hour: string + title: string + image: string + place: string")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" ScheduleCardByPlace "),
  /*#__PURE__*/_createElementVNode("span", null, "hour: string + title: string + image: string")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, "AlphabetMenu", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" GuestLinkCards "),
  /*#__PURE__*/_createElementVNode("span", null, "guests: [ { name: string + image: string } ]")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" GuestCard "),
  /*#__PURE__*/_createElementVNode("span", null, "name: string + date: string + hour: string + place: string + image: string")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode("Copyrights "),
  /*#__PURE__*/_createElementVNode("span", null, "text: string")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode("SeparatorBar "),
  /*#__PURE__*/_createElementVNode("span", null, "text: string")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" EventGuestImage "),
  /*#__PURE__*/_createElementVNode("span", null, "title: string + image: string")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" Contact "),
  /*#__PURE__*/_createElementVNode("span", null, "telephone: string + website: string + email: string")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" ContactLeft "),
  /*#__PURE__*/_createElementVNode("span", null, "telephone: string + website: string + email: string")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode("TextField "),
  /*#__PURE__*/_createElementVNode("span", null, "text: string")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("COLLECTIONS"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" EventGuestTitleBar"),
  /*#__PURE__*/_createElementVNode("span", null, "country: string + eventTitle: string + btnText: string + tagText: [string] + origin: string")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" EventSchedule"),
  /*#__PURE__*/_createElementVNode("span", null, "date: string + hour: string + place: [string]")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" EventGuestHeader"),
  /*#__PURE__*/_createElementVNode("span", null, "routeName: string + params: { type: string, id: string } + stateMenuFilter: string")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode("ScheduleByHourGrid"),
  /*#__PURE__*/_createElementVNode("span", null, "hour: date | number")
], -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" The cards that populate the grid require a match with the hour prop ")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode("ScheduleByPlaceGrid"),
  /*#__PURE__*/_createElementVNode("span", null, "placeId: string")
], -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" The cards that populate the grid require a match with the placeId prop ")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" MainHeader"),
  /*#__PURE__*/_createElementVNode("span", null, "route: { name: string, type: string, id: string } + guestTypes: [string] + programs: [ {} ] + text: string + stateMenuFilter: [string] + showSelect: boolean")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "demo" }, [
  /*#__PURE__*/_createTextVNode(" MainHeaderSortMenu"),
  /*#__PURE__*/_createElementVNode("span", null, "category: [string] + selectItems: [string] + route: string")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreLoader = _resolveComponent("PreLoader")!
  const _component_Language = _resolveComponent("Language")!
  const _component_TagSelect = _resolveComponent("TagSelect")!
  const _component_ButtonShare = _resolveComponent("ButtonShare")!
  const _component_SharePopup = _resolveComponent("SharePopup")!
  const _component_DayMenuButtons = _resolveComponent("DayMenuButtons")!
  const _component_ScheduleDayMenuButtons = _resolveComponent("ScheduleDayMenuButtons")!
  const _component_TagContainer = _resolveComponent("TagContainer")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SocialMediaButtons = _resolveComponent("SocialMediaButtons")!
  const _component_ScheduleCardByHour = _resolveComponent("ScheduleCardByHour")!
  const _component_ScheduleCardByPlace = _resolveComponent("ScheduleCardByPlace")!
  const _component_AlphabetMenu = _resolveComponent("AlphabetMenu")!
  const _component_GuestLinkCards = _resolveComponent("GuestLinkCards")!
  const _component_GuestCard = _resolveComponent("GuestCard")!
  const _component_Copyrights = _resolveComponent("Copyrights")!
  const _component_SeparatorBar = _resolveComponent("SeparatorBar")!
  const _component_EventGuestImage = _resolveComponent("EventGuestImage")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_ContactLeft = _resolveComponent("ContactLeft")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_EventGuestTitleBar = _resolveComponent("EventGuestTitleBar")!
  const _component_EventSchedule = _resolveComponent("EventSchedule")!
  const _component_EventGuestHeader = _resolveComponent("EventGuestHeader")!
  const _component_ScheduleByHourGrid = _resolveComponent("ScheduleByHourGrid")!
  const _component_ScheduleByPlaceGrid = _resolveComponent("ScheduleByPlaceGrid")!
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainHeaderSortMenu = _resolveComponent("MainHeaderSortMenu")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_PreLoader),
    _hoisted_4,
    _createVNode(_component_Language),
    _hoisted_5,
    _createVNode(_component_TagSelect, {
      title: "Tag",
      selectItems: _ctx.selectItems
    }, null, 8, ["selectItems"]),
    _hoisted_6,
    _createVNode(_component_ButtonShare, {
      text: "partager",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePopup()))
    }),
    _createElementVNode("div", {
      ref: "sharepopup",
      onFocusout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closePopup())),
      tabindex: "0"
    }, [
      _withDirectives(_createVNode(_component_SharePopup, {
        style: _normalizeStyle(this.origin === 'anEvent' ? { top: '100px' } : { top: '40px' })
      }, null, 8, ["style"]), [
        [_vShow, this.popup]
      ])
    ], 544),
    _hoisted_7,
    _createVNode(_component_SharePopup),
    _hoisted_8,
    _createVNode(_component_DayMenuButtons, { text: _ctx.btnDay }, null, 8, ["text"]),
    _hoisted_9,
    _createVNode(_component_ScheduleDayMenuButtons, { text: _ctx.btnDay }, null, 8, ["text"]),
    _hoisted_10,
    _createVNode(_component_TagContainer, { text: _ctx.tagText }, null, 8, ["text"]),
    _hoisted_11,
    _createVNode(_component_SearchBar),
    _hoisted_12,
    _createVNode(_component_Select, {
      selectItems: _ctx.selectItems,
      title: "Programme"
    }, null, 8, ["selectItems"]),
    _hoisted_13,
    _createVNode(_component_Button, {
      link: _ctx.button.link,
      mainColor: _ctx.button.mainColor,
      hoverColor: _ctx.button.hoverColor,
      text: "accueil"
    }, null, 8, ["link", "mainColor", "hoverColor"]),
    _hoisted_14,
    _createVNode(_component_SocialMediaButtons, {
      youtube: _ctx.socialMedia.youtube,
      spotify: _ctx.socialMedia.spotify,
      soundcloud: _ctx.socialMedia.soundcloud,
      facebook: _ctx.socialMedia.facebook,
      twitter: _ctx.socialMedia.twitter,
      instagram: _ctx.socialMedia.instagram,
      deezer: _ctx.socialMedia.deezer
    }, null, 8, ["youtube", "spotify", "soundcloud", "facebook", "twitter", "instagram", "deezer"]),
    _hoisted_15,
    _createVNode(_component_ScheduleCardByHour, {
      hour: _ctx.scheduleCardByHour.hour,
      place: _ctx.scheduleCardByHour.place,
      title: _ctx.scheduleCardByHour.name,
      image: _ctx.scheduleCardByHour.image,
      id: _ctx.scheduleCardByHour.id,
      event: _ctx.scheduleCardByHour,
      link: _ctx.scheduleCardByHour.link
    }, null, 8, ["hour", "place", "title", "image", "id", "event", "link"]),
    _hoisted_16,
    _createVNode(_component_ScheduleCardByPlace, {
      hour: _ctx.scheduleCardByPlace.hour,
      title: _ctx.scheduleCardByPlace.event,
      image: _ctx.scheduleCardByPlace.image
    }, null, 8, ["hour", "title", "image"]),
    _hoisted_17,
    _createVNode(_component_AlphabetMenu),
    _hoisted_18,
    _createVNode(_component_GuestLinkCards, { guests: _ctx.guestData }, null, 8, ["guests"]),
    _hoisted_19,
    _createVNode(_component_GuestCard, {
      name: _ctx.guestCard.name,
      date: _ctx.guestCard.date,
      hour: _ctx.guestCard.hour,
      place: _ctx.guestCard.place,
      image: _ctx.guestCard.image
    }, null, 8, ["name", "date", "hour", "place", "image"]),
    _hoisted_20,
    _createVNode(_component_Copyrights, { text: _ctx.copyright }, null, 8, ["text"]),
    _hoisted_21,
    _createVNode(_component_SeparatorBar, { text: _ctx.separatorText }, null, 8, ["text"]),
    _hoisted_22,
    _createVNode(_component_EventGuestImage, {
      image: _ctx.eventGuestImage.image,
      title: _ctx.eventGuestImage.title
    }, null, 8, ["image", "title"]),
    _hoisted_23,
    _createVNode(_component_Contact, {
      telephone: _ctx.contact.telephone,
      website: _ctx.contact.website,
      email: _ctx.contact.email
    }, null, 8, ["telephone", "website", "email"]),
    _hoisted_24,
    _createVNode(_component_ContactLeft, {
      telephone: _ctx.contact.telephone,
      website: _ctx.contact.website,
      email: _ctx.contact.email
    }, null, 8, ["telephone", "website", "email"]),
    _hoisted_25,
    _createVNode(_component_TextField, { text: _ctx.text }, null, 8, ["text"]),
    _hoisted_26,
    _hoisted_27,
    _createVNode(_component_EventGuestTitleBar, {
      country: _ctx.eventGuestTitleBar.country,
      eventTitle: _ctx.eventGuestTitleBar.eventTitle,
      btnText: _ctx.btnShareText,
      tagText: _ctx.tagText,
      origin: "anEvent"
    }, null, 8, ["country", "eventTitle", "btnText", "tagText"]),
    _hoisted_28,
    _createVNode(_component_EventSchedule, {
      link: _ctx.eventSchedule.link,
      date: _ctx.eventSchedule.date,
      hour: _ctx.eventSchedule.hour,
      place: _ctx.eventSchedule.place,
      name: _ctx.eventSchedule.name
    }, null, 8, ["link", "date", "hour", "place", "name"]),
    _hoisted_29,
    _createVNode(_component_EventGuestHeader, {
      routeName: _ctx.schedule,
      params: { type: 'TYPE', id: 'ID' },
      stateMenuFilter: "monday 1"
    }, null, 8, ["routeName"]),
    _hoisted_30,
    _hoisted_31,
    _createVNode(_component_ScheduleByHourGrid, { hour: "1647484200000" }),
    _hoisted_32,
    _hoisted_33,
    _createVNode(_component_ScheduleByPlaceGrid, {
      placeId: _ctx.scheduleByHour[0].id
    }, null, 8, ["placeId"]),
    _hoisted_34,
    _createVNode(_component_MainHeader, {
      route: { name: 'main', type: 'type', id: 'id' },
      showSelect: true,
      text: "programmation",
      programs: _ctx.programs,
      guestTypes: _ctx.guestTypes,
      stateMenuFilter: _ctx.sortedDays[0]
    }, null, 8, ["programs", "guestTypes", "stateMenuFilter"]),
    _hoisted_35,
    _createVNode(_component_MainHeaderSortMenu, {
      category: _ctx.categorySchedule,
      selectItems: _ctx.selectItems,
      route: "main"
    }, null, 8, ["category", "selectItems"])
  ]))
}